import React, { useState } from 'react';
import { Link, navigate } from 'gatsby';
import useFocus from '../../hooks/useFocus';
import SearchIcon from '../SVGs/SearchIcon';
import LocationIconWhite from '../SVGs/LocationIconWhite';
import useMediaQuery from '../../hooks/useMediaQuery';

const SearchBox = () => {
  const [searchOpen, setSearchOpen] = useState(false);
  const [search, setSearch] = useState('');
  const [htmlElRef, setInputFocus] = useFocus();

  const isSmallScreen = useMediaQuery('(max-width: 600px)');

  const searchPlaceholder = isSmallScreen ? 'Type to Search Dorot Gardens' : 'Type to Search';

  const openSearchBox = () => {
    setSearchOpen(true);
    setInputFocus();
  };

  const handleClick = (e) => {
    e.preventDefault(); // Prevent default form submission
    if (searchOpen) {
      if (search) {
        handleSearch();
      }
    } else {
      openSearchBox();
    }
  };

  const handleSearch = () => {
    const searchQuery = search ? `?q=${encodeURIComponent(search)}` : '';
    const currentPath = typeof window !== 'undefined' ? window.location.pathname : '';

    if (currentPath.includes('search') && search) {
      navigate(`/search${searchQuery}`, { replace: true });
    } else if (search) {
      navigate(`/search${searchQuery}`);
    }
  };

  const searchHandler = (e) => {
    const searchTerm = e.target.value;
    setSearch(searchTerm);
  };

  return (
    <div id="search-box" className="1024:w-[200px] lg:min-w-[322px]">
      <div
        className={`md:flex lg:gap-x-12.5 justify-end items-center ${
          searchOpen ? '1024:bg-accent-purple 1024:rounded-xl 1024:border border-solid border-white' : ''
        }`}
      >
        {!searchOpen && (
          <div className="hidden lg:flex gap-x-1 items-center">
            <LocationIconWhite />
            <Link to='/where-to-find' className="text-white text-_1625 font-goldplay font-semibold">Find us at the freezer aisle</Link>
          </div>
        )}

        {searchOpen && (
          <form
            className="w-full absolute inset-x-0 top-[55px] md:top-[100px] z-[100] 1024:static"
            onSubmit={(e) => {
              e.preventDefault();
              handleSearch();
            }}
          >
            <input
              ref={htmlElRef}
              onChange={searchHandler}
              name="q"
              autoComplete="off"
              placeholder={searchPlaceholder}
              className="placeholder:text-white font-goldplay w-full px-7.5 py-2 md:px-3.5 md:py-3 lg:px-5.5 focus:outline-none 1024:rounded-xl bg-accent-purple text-white"
            />
          </form>
        )}

        <div className="pr-3.5 py-2.5 cursor-pointer search-btn" onClick={handleClick}>
          <SearchIcon />
        </div>
      </div>
    </div>
  );
};

export default SearchBox;